<template>
  <div class="shopInformation">
    <headerBar title="农产品溯源中心"></headerBar>
    <companyBar :store_name="store_name" :logo="store_logo"></companyBar>
    <div v-if="page_type == 0" class="shenhenotice">信息审核中,请耐心等待!</div>
    <div v-if="page_type != 0">
      <div class="shenheresult" v-if="page_type == -1">
        信息审核失败，失败原因:
        <span>{{ refuse_msg }}</span>
      </div>
      <div class="box710">
        <div class="item">
          <span>营业执照/信用代码:</span>
          <input type="text" placeholder="请填写代码(必填)" v-model="business_identity" />
        </div>
        <div class="item">
          <span>联系人</span>
          <input type="text" placeholder="请填写联系人姓名(必填)" v-model="leader" />
        </div>
        <div class="item">
          <span>联系电话</span>
          <input type="text" placeholder="请填写联系电话(必填)" v-model="store_mobile" />
        </div>
        <div class="item">
          <span>联系地址</span>
          <input style="width: 5rem;" type="text" placeholder="请填写联系地址(必填)" v-model="address" />
        </div>
        <div class="item">
          <span>法人身份证</span>
          <input type="text" placeholder="请填写法人身份证(必填)" v-model="corporation_identity" />
        </div>
        <div class="item">
          <span>法人姓名</span>
          <input type="text" placeholder="请填写法人姓名(必填)" v-model="corporation" />
        </div>
      </div>
      <div class="box710">
        <div class="item1">
          <p class="title">营业执照/信用代码</p>
          <p class="notice">需要上传在有效期内的营业执照，并且为原件照片</p>
          <div class="up-load" v-if="!business_license_64">
            <div class="default" @click="upLoadImgBtn(1)"><img class="default-img" src="../../static/images/canmera.png" alt="" /></div>
            <p>*请必须上传(图片需清晰完整)</p>
          </div>
          <img
            class="upload-show"
            @click="upLoadImgBtn(1)"
            v-if="business_license_64 && business_license_64.indexOf('upload/') > -1"
            :src="'https://yuan.znstny.cn/' + business_license_64"
            alt=""
          />
          <img class="upload-show" @click="upLoadImgBtn(1)" v-if="business_license_64 && business_license_64.indexOf('upload/') == -1" :src="business_license_64" alt="" />
        </div>
        <div class="item1">
          <p class="title">食品经营许可证</p>
          <p class="notice">需要上传在有效期内的食品经营许可证，并且为原件照片</p>
          <div class="up-load" v-if="!food_license_64">
            <div class="default" @click="upLoadImgBtn(2)"><img class="default-img" src="../../static/images/canmera.png" alt="" /></div>
            <p>*请必须上传(图片需清晰完整)</p>
          </div>
          <img
            class="upload-show"
            @click="upLoadImgBtn(2)"
            v-if="food_license_64 && food_license_64.indexOf('upload/') > -1"
            :src="'https://yuan.znstny.cn/' + food_license_64"
            alt=""
          />
          <img class="upload-show" @click="upLoadImgBtn(2)" v-if="food_license_64 && food_license_64.indexOf('upload/') == -1" :src="food_license_64" alt="" />
        </div>
        <div class="item1">
          <p class="title">法人身份证</p>
          <p class="notice">需要上传在有效期内的法人身份证，并且为原件照片</p>
          <div class="up-load" v-if="!corporation_license_64">
            <div class="default" @click="upLoadImgBtn(3)"><img class="default-img" src="../../static/images/canmera.png" alt="" /></div>
            <p>*请必须上传(图片需清晰完整)</p>
          </div>
          <img
            class="upload-show"
            @click="upLoadImgBtn(3)"
            v-if="corporation_license_64 && corporation_license_64.indexOf('upload/') > -1"
            :src="'https://yuan.znstny.cn/' + corporation_license_64"
            alt=""
          />
          <img class="upload-show" @click="upLoadImgBtn(3)" v-if="corporation_license_64 && corporation_license_64.indexOf('upload/') == -1" :src="corporation_license_64" alt="" />
        </div>
        <div class="item1">
          <p class="title">企业LOGO</p>
          <p class="notice">企业最新LOGO，并且为原件照片</p>
          <div class="up-load" v-if="!logo_64">
            <div class="default" @click="upLoadImgBtn(4)"><img class="default-img" src="../../static/images/canmera.png" alt="" /></div>
            <p>可以选择上传(图片需清晰完整)</p>
          </div>
          <img class="upload-show" @click="upLoadImgBtn(4)" v-if="logo_64 && logo_64.indexOf('upload/') > -1" :src="'https://yuan.znstny.cn/' + logo_64" alt="" />
          <img class="upload-show" @click="upLoadImgBtn(4)" v-if="logo_64 && logo_64.indexOf('upload/') == -1" :src="logo_64" alt="" />
        </div>

        <p style="color: red;padding: 0.2rem 0;">注：以上加*信息都为必填项</p>
      </div>
      <div class="kuang" @click="submitBtn">
        <div class="bgmask"></div>
        <p>提交</p>
      </div>
      <div class="save"  @click="doSave()"><p>保存</p></div>
    </div>

    <input type="file" id="imgupload" @change="uploadImg(uploadType, $event)" style="display:none" />
  </div>
</template>

<script>
import { Toast, MessageBox } from 'mint-ui';
export default {
  data() {
    return {
      store_name: '',
      store_logo: '',
      business_identity: '', //营业执照代码
      leader: '', //联系人姓名
      store_mobile: '',
      address: '',
      corporation_identity: '', //法人身份证号码
      corporation: '',
      business_license: '', //营业执照照片
      business_license_64: '',
      food_license: '', //食品许可证
      food_license_64: '',
      corporation_license: '', //法人身份证
      corporation_license_64: '',
      logo: '',
      logo_64: '',
      page_type: 0, //status -2 未完善信息  0 审核中 1审核通过 -1 审核失败
      uploadType: 0, //上传参数初始
      refuse_msg: '审核失败' //审核失败的原因;
    };
  },
  created() {
  },
  mounted() {
    //判断登陆状态,
    if (!window.localStorage.getItem('is_check_login') || window.localStorage.getItem('is_check_login') == 0) {
      //登陆失败
      this.$router.push('/login');
    } else {
      this.checkShopInfo();
    }
  },
  destroyed() {
    MessageBox.close();
  },
  methods: {
    checkShopInfo() {
      //检查商家信息
      this.$request.post(
        '/front/Store/info',
        {
          // id: window.localStorage.getItem('store_id'),
          // token: window.localStorage.getItem('token')
        },
        res => {
          console.log(res);
          if (res.status == 1) {
            this.page_type = res.result.apply_states; //status -2 未完善信息  0 审核中 1审核通过 -1 审核失败
            this.store_name = res.result.store_name;
            this.store_logo = res.result.logo;

            if (res.result.apply_states == -1) {
              //审核失败。重新提交
              this.business_identity = res.result.business_identity;
              this.leader = res.result.leader;
              this.store_mobile = res.result.store_mobile;
              this.address = res.result.address;
              this.corporation_identity = res.result.corporation_identity;
              this.corporation = res.result.corporation;
              this.business_license_64 = res.result.business_license;
              this.business_license = res.result.business_license;
              this.food_license_64 = res.result.food_license;
              this.food_license = res.result.food_license;
              this.corporation_license_64 = res.result.corporation_license;
              this.corporation_license = res.result.corporation_license;
              this.logo_64 = res.result.logo;
              this.logo = res.result.logo;
              this.refuse_msg = res.result.refuse_msg || '审核失败';
            } else if (res.result.apply_states == 1) {
              this.$router.push('/projectList');
            } else if (res.result.apply_states == -2) {
              this.business_identity = res.result.business_identity;
              this.leader = res.result.leader;
              this.store_mobile = res.result.store_mobile;
              this.address = res.result.address;
              this.corporation_identity = res.result.corporation_identity;
              this.corporation = res.result.corporation;
              this.business_license_64 = res.result.business_license;
              this.business_license = res.result.business_license;
              this.food_license_64 = res.result.food_license;
              this.food_license = res.result.food_license;
              this.corporation_license_64 = res.result.corporation_license;
              this.corporation_license = res.result.corporation_license;
              this.logo_64 = res.result.logo;
              this.logo = res.result.logo;
            }
          }else{
            Toast(res.msg)
          }
        }
      );
    },
    uploadImg(uploadType, e) {
      let file = e.target.files[0];
      console.log(uploadType, e);
      let type = file.type.split('/')[0];
      if (type == 'image') {
        //图片转成base64
        let reader = new FileReader();
        reader.readAsDataURL(file);
        //上传
        reader.onloadend = () => {
          let dataUrl = reader.result;
          if (uploadType == 1) {
            //上传营业执照
            this.business_license_64 = dataUrl;
            this.business_license = file;
          } else if (uploadType == 2) {
            //食品许可
            this.food_license_64 = dataUrl;
            this.food_license = file;
          } else if (uploadType == 3) {
            //法人身份证
            this.corporation_license_64 = dataUrl;
            this.corporation_license = file;
          } else if (uploadType == 4) {
            //logo
            this.logo_64 = dataUrl;
            this.logo = file;
          }
          e.target.value = '';
        };
      } else {
        Toast('请上传图片');
      }
    },
    upLoadImgBtn(type) {
      this.uploadType = type;
      document.getElementById('imgupload').click();
    },
    submitBtn() {
      this.postForm();
    },
    postForm() {
      if (!this.business_identity || this.business_identity == '') {
        Toast('请填写营业执照/信用代码');
        return false;
      }
      if (!this.leader || this.leader == '') {
        Toast('请填写联系人姓名');
        return false;
      }
      if (!this.store_mobile || this.store_mobile == '') {
        Toast('请填写联系方式');
        return false;
      }
      if (!this.address || this.address == '') {
        Toast('请填写联系地址');
        return false;
      }
      if (!this.corporation_identity || this.corporation_identity == '') {
        Toast('请填写法人身份证号码');
        return false;
      }
      if (!this.corporation || this.corporation == '') {
        Toast('请填写法人姓名');
        return false;
      }

      if (!this.business_license || this.business_license == '') {
        Toast('请上传营业执照照片');
        return false;
      }
      if (!this.food_license || this.food_license == '') {
        Toast('请上传食品许可证');
        return false;
      }
      if (!this.corporation_license || this.corporation_license == '') {
        Toast('请上传法人身份证');
        return false;
      }
      /* if (!this.logo || this.logo == '') {
        Toast('请上传企业logo');
        return false;
      } */
      this.saveInfo(1);
    },
    doSave(){
      this.saveInfo(0)
    },
    saveInfo(isSubmit=1){
      let data = new FormData();
      data.append('business_identity', this.business_identity);
      data.append('leader', this.leader);
      data.append('store_mobile', this.store_mobile);
      data.append('address', this.address);
      data.append('corporation_identity', this.corporation_identity);
      data.append('corporation', this.corporation);
      data.append('business_license', this.business_license);
      data.append('food_license', this.food_license);
      data.append('corporation_license', this.corporation_license);
      data.append('logo', this.logo);
      data.append('is_submit', isSubmit);
      this.$request.post('/front/Appsto/applysto', data, res => {
        if (res.status == 1) {
          if(isSubmit==1){
            this.page_type = 0; //审核中
            Toast(res.msg);
          }else{
            Toast('保存成功');
          }
        }else{
          Toast(res.msg);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.shopInformation {
  padding-top: 0.8rem;
  .shenhenotice {
    font-size: 0.48rem;
    font-weight: bold;
    text-align: center;
    color: #299e72;
    margin-top: 2rem;
  }
  .shenheresult {
    width: 100%;
    height: auto;
    padding: 0.2rem;
    box-sizing: border-box;
    span {
      color: #299e72;
    }
  }
  .box710 {
    background: white;
    padding: 0 0.2rem;
    .item {
      width: 100%;
      height: 1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #cccccc;
      input {
        height: 0.9rem;
        text-align: right;
      }
    }
    .item:last-child {
      border: none;
    }
    .item1 {
      font-size: 0.28rem;
      padding-bottom: 0.2rem;
      border-bottom: 1px solid #cccccc;
      .title {
        height: 0.8rem;
        line-height: 0.8rem;

        color: #000000;
      }
      .notice {
        height: 0.5rem;
        border-radius: 5px;
        line-height: 0.5rem;
        background: #fdf4cd;
        color: #666666;
        padding-left: 0.2rem;
        font-size: 0.24rem;
      }
      .up-load {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        margin-top: 0.3rem;
        .default {
          width: 1.4rem;
          height: 1.4rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border: 1px solid #cccccc;
          border-radius: 5px;
          position: relative;
          .default-img {
            width: 0.6rem;
            margin: 0 auto;
          }
        }
        p {
          color: #999999;
        }
      }
      .upload-show {
        display: block;
        margin-top: 0.2rem;
        width: 1.4rem;
        height: 1.4rem;
        border-radius: 5px;
      }
    }
    .item1:last-child {
      border: none;
    }
  }
  .kuang {
    margin-top: 1rem;
    border-color: #299e72;
    .bgmask {
      background: #299e72;
    }
    p {
      color: #299e72;
      font-size: 0.38rem;
    }
  }
}
.save{
  margin: 0.3rem auto 0.6rem;width: 5rem; text-align: center; line-height: .8rem;
  border-radius: 5px;
   background: #750505;
   color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopInformation.vue